export const postsCategoriesTabHeaders = [
  { key: 'drag', label: '', sortable: false },
  { key: 'title', label: 'Title', sortable: true },
  { key: 'PostsCount', label: 'Posts Count', sortable: false },
  { key: 'createdDate', label: 'Created Date', sortable: true },
  { key: 'updatedDate', label: 'Updated Date', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'action', label: 'Action', sortable: false },
];
